import type { PayloadAction } from '@reduxjs/toolkit';
import { AddPaymentSplitRequestBody } from '@/domains/payments/features/paymentModals/modals/AddPaymentSplit/types/AddPaymentSplitRequestBody';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Modals } from '@/features/serviceModal/enums/Modals';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { getPayments } from '@/domains/payments/features/PaymentsSection/store/payments.slice';
import { addPaymentSplit } from '@/domains/payments/features/paymentModals/modals/AddPaymentSplit/store/addPaymentSplit.slice';
import PaymentFormEvent from '@/domains/payments/features/paymentModals/shared/events';
import EventService from '@/services/EventService/EventService';
import HttpService from '@/services/HttpService/HttpService';
import ModalService from '@/services/ModalService/ModalService';
import SnacksService from '@/services/SnackService/SnackService';

function* addPaymentSplitSaga({ payload }: PayloadAction<AddPaymentSplitRequestBody & { claimId: number }>) {
  try {
    const { claimId, ...body } = payload;
    yield call(HttpService.post, '/Payment/add-payment-split', body, {
      baseURL: import.meta.env.VITE_API_URL,
    });

    SnacksService.add({
      type: SnackType.Success,
      title: 'Payment Split has been added successfully',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
    ModalService.close(Modals.AddPaymentSplit);
    yield put(getPayments({ claimId: payload.claimId }));
  } catch (error) {
    console.error(error);
    ModalService.close(Modals.AddPaymentSplit);
  } finally {
    EventService.dispatch(new PaymentFormEvent.CreateRequestSuccess({}));
  }
}

export function* addPaymentSplitWatcher() {
  yield takeLatest([addPaymentSplit.type], addPaymentSplitSaga);
}
